(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3935],{

/***/ 55352:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/chatgpt",
      function () {
        return __webpack_require__(45494);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_core_components_chat_history_AiChatHistoryPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6074);
/* harmony import */ var src_core_components_chat_history__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15793);



const AndroidLocalChatGPTPage = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_chat_history_AiChatHistoryPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        category: src_core_components_chat_history__WEBPACK_IMPORTED_MODULE_2__/* .AI_CATEGORIES.CHATGPT */ .$Q.CHATGPT,
        title: "ChatGPT",
        mode: "android-local"
    });
/* harmony default export */ __webpack_exports__["default"] = (AndroidLocalChatGPTPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1954,1033,8914,3368,1675,5378,6074,9774,2888,179], function() { return __webpack_exec__(55352); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);